import { render, staticRenderFns } from "./jobCard.vue?vue&type=template&id=806dee1c&scoped=true"
import script from "./jobCard.vue?vue&type=script&lang=js"
export * from "./jobCard.vue?vue&type=script&lang=js"
import style0 from "./jobCard.vue?vue&type=style&index=0&id=806dee1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806dee1c",
  null
  
)

export default component.exports